/**
 * Start over (TMMAPI-0157, TMMAPP-0119 §E 26c): `POST /v1/me/data-reset {confirmation}` deletes the
 * caller's own data and keeps the login, the subscription, the AI wallet, statements and consents.
 * The confirmation is the account's email (`422 CONFIRMATION_REQUIRED` otherwise); it's refused
 * while locked (`403 SUBSCRIPTION_EXPIRED`).
 */
import type { DataResetRequest, DataResetView } from './generated';
import { request } from './client';

export interface DataReset {
  resetAt: string;
  /** What was deleted, by tmm-api's table name. */
  counts: Readonly<Record<string, number>>;
}

export function normalizeDataReset(w: DataResetView): DataReset {
  return { resetAt: w.resetAt, counts: { ...w.counts } };
}

export const dataResetApi = {
  async reset(confirmation: string): Promise<DataReset> {
    const body: DataResetRequest = { confirmation };
    return normalizeDataReset(
      await request<DataResetView>('POST', '/v1/me/data-reset', { json: body }),
    );
  },
};
